module.exports = __webpack_public_path__ + "static/media/heldane-text-web-regular-italic.388ff9ec.eot";